import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Glyph from 'component/utils/Glyph'
import moment from 'moment'
import DownloadSvg from 'images/download_green.svg'
import TableArrowDown from 'component/svgComponents/tableArrowDown'

export default class QueryLogsTable extends PureComponent {
  static propTypes = {
    logs: PropTypes.array.isRequired,
    openModal: PropTypes.func.isRequired,
    handleDownload: PropTypes.func.isRequired,
    fetchDir: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    initialDirection: PropTypes.string,
    functionality: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.state = {
      direction: props.initialDirection || 'asc'
    }
    this.tableRef = React.createRef()
    this.tbodyRef = React.createRef()
    this.height = 0
  }

  componentDidMount() {
    this.setHeight(window.innerHeight)
    const calculateHeight = () => {
      this.setHeight(window.innerHeight)
    }
    window.addEventListener("resize", calculateHeight)
    this.calculateHeightCleanup = () => {
      window.removeEventListener("resize", calculateHeight)
    }
  }

  componentWillUnmount() {
    if (this.calculateHeightCleanup) {
      this.calculateHeightCleanup()
    }
  }

  setHeight = (height) => {
    this.height = height
    this.updateTbodyHeight()
  }

  updateTbodyHeight = () => {
    if (!this.tbodyRef.current || this.height === 0) return
    const PAGINATION_HEIGHT = 71
    const TOP_ACTIONS = 95
    const TOP_BAR = 67 + 50
    const responsiveHeight = this.height < 868
      ? this.height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100)
      : 500
    this.tbodyRef.current.style.maxHeight = `${responsiveHeight}px`
  }

  componentDidUpdate(prevProps) {
    const { initialDirection } = this.props
    if (initialDirection && initialDirection !== prevProps.initialDirection) {
      this.setState({ direction: initialDirection })
    }
    this.updateTbodyHeight()
  }

  renderCode = (code) => code.length > 70 ? code.slice(0, 70).concat('[...]') : code

  renderRows = ({ request, response, endpoint, idInventory, date, transactionSap }) => {
    const { handleDownload, openModal, translate, functionality } = this.props

    const displayResponse = functionality === 'demarcate' && response === 'REJECTED'
      ? translate('query.logs.demarcate.response.rejected')
      : response

    return (
      <tr key={idInventory}>
        <td className='overflow-wrap-anywhere query-logs-table-cell query-logs-table-cell-date'>
          <span>{moment(date).format('DD/MM/YYYY HH:mm:ss') || '-'}</span>
        </td>
        <td className='overflow-wrap-anywhere query-logs-table-cell query-logs-table-cell-request'>
          <span>{this.renderCode(request) || '-'}</span>
        </td>
        <td className='overflow-wrap-anywhere query-logs-table-cell query-logs-table-cell-response'>
          <span>{this.renderCode(displayResponse) || '-'}</span>
        </td>
        <td className='text-align-center query-logs-table-cell query-logs-table-cell-view'>
          <Glyph
            type='eye'
            color='primary'
            customClass='cursor-pointer'
            onClick={() => openModal({ request, response, endpoint, date, transactionSap })}
            disabled={false}
          />
        </td>
        <td className='text-align-center query-logs-table-cell query-logs-table-cell-download'>
          <img
            src={DownloadSvg}
            width={20}
            height={20}
            className='cursor-pointer'
            onClick={() => handleDownload({ date, endpoint, request, response })}
          />
        </td>
      </tr>
    )
  }

  changeDir = () => {
    const { fetchDir } = this.props
    const { direction } = this.state

    const newDirection = direction === 'asc' ? 'desc' : 'asc'
    
    this.setState({
      direction: newDirection
    }, () => fetchDir(newDirection))
  }

  handleScroll = (e) => {
    if (e.currentTarget.scrollTop > 20) {
      if (this.tableRef.current) {
        this.tableRef.current.classList.add("shadow-table-header-mission-block")
      }
    } else {
      if (this.tableRef.current) {
        this.tableRef.current.classList.remove("shadow-table-header-mission-block")
      }
    }
  }

  renderHeader = () => {
    const { translate, initialDirection } = this.props
    const { direction } = this.state
    const currentDirection = direction || initialDirection || 'asc'
    const isAscending = currentDirection === 'asc'

    return (
      <tr className='pictograms-tr'>
        <th className='overflow-wrap-anywhere query-logs-table-header query-logs-table-header-date' onClick={() => this.changeDir()}>
          <span className='query-logs-table-header-span'>{translate('totem.reports.modal.table.header.timestamp')}</span>
          <TableArrowDown 
            active={true} 
            reverse={isAscending} 
            hide={false}
          />
        </th>
        <th className='query-logs-table-header query-logs-table-header-request'>{translate('queryLogs.table.column.request')}</th>
        <th className='query-logs-table-header query-logs-table-header-response'>{translate('queryLogs.table.column.response')}</th>
        <th className='text-align-center query-logs-table-header query-logs-table-header-view'>
          {translate('videos.view')}
        </th>
        <th className='text-align-center query-logs-table-header query-logs-table-header-download'>
          {translate('purchase_price.button.download')}
        </th>
      </tr>
    )
  }

  renderBody = () => {
    const { logs } = this.props
    if (!logs || logs.length === 0) {
      return (
        <tr>
          <td colSpan="5" className='query-logs-table-empty'>
            No data available
          </td>
        </tr>
      )
    }
    return logs.map(this.renderRows)
  }

  render() {
    return (
      <div className='query-logs-new table-scroll-wrapper'>
        <table
          cellPadding={0}
          cellSpacing={0}
          className='mission-block-table-new new pictograms-table'
        >
            <thead ref={this.tableRef}>{this.renderHeader()}</thead>
            <tbody
              ref={this.tbodyRef}
              className='tbody-mission-block'
              onScroll={this.handleScroll}
            >
          {this.renderBody()}
        </tbody>
      </table>
    </div>
    )
  }
}
